<template>
  <!--头部导航栏-->
  <div class="header-bar">
    <a-menu mode="horizontal">
      <a-menu-item style="width: 145px;padding: 0;line-height: 10vh">
        <router-link @click.passive="backtotop" :to="'/index'">
          <img src="../../assets/logo.svg" style="width: 145px;height: 40px;">
        </router-link>
      </a-menu-item>

      <a-menu-item v-for="(item, index) in routers" :key="index" class="item" :id="index">
        <router-link :to="item.url" @click.passive="backtotop">{{ item.title }}</router-link>
      </a-menu-item>

      <a-menu-item style="width: 2vw;line-height: 10vh;padding: 0">
          <img src="../../assets/en.png" style="height: 25px;width: 25px;margin-bottom: 9px" @click.passive="to">
      </a-menu-item>
      <a-menu-item style="width: 3vw;line-height: 10vh;padding: 0 0.4vw 0 0.5vw;">
        <router-link :to="'/index'" @click.passive="backtotop">
          <HomeOutlined :style="{fontSize: '22px', margin: '0',}"/>
        </router-link>
      </a-menu-item>

      <a-menu-item style="width: 2vw;line-height: 10vh;padding: 0">
        <router-link :to="'/search'">
          <SearchOutlined :style="{fontSize: '22px', margin: '0'}"/>
        </router-link>
      </a-menu-item>
    </a-menu>
  </div>
</template>

<script>
import {reactive} from 'vue'
import {SearchOutlined, HomeOutlined} from '@ant-design/icons-vue'

export default {
  name: 'Header',
  components: {
    SearchOutlined,
    HomeOutlined,
  },
  watch: {
    $route (to) {
      if (to.name === "Team_partner") {
        document.getElementById('2').click()
      }
      else if(to.name === "Enterprise"){
        document.getElementById('3').click()
      }
      else if(to.name === 'News'){
        document.getElementById('4').click()
      }
    }
  },
  setup() {
    const routers = reactive([  //路由对应
      {url: '/index', title: '首页'},
      {url: '/concept', title: '投资理念'},
      {url: '/team', title: '投资团队'},
      {url: '/enterprise', title: '被投企业'},
      {url: '/news', title: '公司新闻'},
      {url: '/contact', title: '联系我们'},
    ])
    const backtotop = () => {  //回到头部位置
      document.documentElement.scrollTo(0, 0)
    }
    const to = () => {
      let thisPage = window.location.href.toString();
      if (thisPage.search('/index') !== -1) {
        thisPage = thisPage.replace('index', 'index_en')
      } else if (thisPage.search('/concept') !== -1) {
        thisPage = thisPage.toString().replace('concept', 'concept_en')
      } else if (thisPage.search('/team') !== -1) {
        thisPage = thisPage.toString().replace('team', 'team_en')
      } else if (thisPage.search('/enterprise') !== -1) {
        thisPage = thisPage.toString().replace('enterprise', 'enterprise_en')
      } else if (thisPage.search('/news') !== -1) {
        thisPage = thisPage.toString().replace('news', 'news_en')
      } else if (thisPage.search('/contact') !== -1) {
        thisPage = thisPage.toString().replace('contact', 'contact_en')
      } else if (thisPage.search('/search') !== -1){
        thisPage = thisPage.toString().replace('search', 'search_en')
      }
      window.location.href = thisPage
    }

    return {routers, backtotop, to}
  }
}

</script>

<style>
.item {
  width: 11vw;
  line-height: 10vh;
}

.header-bar {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 998;
}


</style>
